module.exports = __webpack_public_path__ + "dc90962a15c2bcf837aaf868a35f92cf.svg";